
export default function About() {
  return (
    <section id="about" className="py-16 lg:py-20 bg-[#FAFAFA]">
      <div className="max-w-[900px] mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-3xl lg:text-[38px] font-semibold text-[#111111] mb-8">
          About Us
        </h2>
        
        <p className="text-[17px] text-[#666666] leading-relaxed mb-6">
          Precious Leader Trade Far East Limited is a Hong Kong-based independent advisory firm specializing in carbon markets, ESG strategy, and precious metals intelligence across Asia-Pacific. We provide strategic guidance, market analysis, and partner introductions to help clients navigate opportunities in environmental and commodity markets.
        </p>

        <p className="text-[17px] text-[#666666] leading-relaxed mb-6">
          With international reach and deep regional expertise, we serve corporate buyers, brokers, project developers, investors, and trading firms seeking execution-oriented advisory and independent analysis.
        </p>

        <div className="inline-block bg-white border border-gray-200 rounded-xl px-6 py-4 mt-4">
          <p className="text-[14px] text-[#666666]">
            We do not provide regulated financial or brokerage services.
          </p>
        </div>
      </div>
    </section>
  );
}